import axios from "axios";
import { getUrl } from "../../../../src/actions/urls";

export const fetchQuestionData = async (questionText) => {
    try {
        const apiUrl = getUrl("ai_modal");
        const response = await axios.post(
            apiUrl,
            {
                question: questionText,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

export const fetchSearchData = async (searchTerm) => {
    try {
        const apiUrl = getUrl("ai_modal");
        const response = await axios.post(
            apiUrl,
            {
                question: searchTerm,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};
